import { render, staticRenderFns } from "./MobileNudge.vue?vue&type=template&id=083fce50&scoped=true&"
import script from "./MobileNudge.vue?vue&type=script&lang=ts&"
export * from "./MobileNudge.vue?vue&type=script&lang=ts&"
import style0 from "./MobileNudge.vue?vue&type=style&index=0&id=083fce50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fce50",
  null
  
)

export default component.exports